import { Filter, FilterType } from '../../search.filter/search-filter.component';

export const usStates = [
  { label: '', id: '' },
  { label: 'Alabama', id: 'AL' },
  { label: 'Alaska', id: 'AK' },
  { label: 'American Samoa', id: 'AS' },
  { label: 'Arizona', id: 'AZ' },
  { label: 'Arkansas', id: 'AR' },
  { label: 'California', id: 'CA' },
  { label: 'Colorado', id: 'CO' },
  { label: 'Connecticut', id: 'CT' },
  { label: 'Delaware', id: 'DE' },
  { label: 'District of Columbia', id: 'DC' },
  { label: 'FS of Micronesia', id: 'FM' },
  { label: 'Florida', id: 'FL' },
  { label: 'Georgia', id: 'GA' },
  { label: 'Guam', id: 'GU' },
  { label: 'Hawaii', id: 'HI' },
  { label: 'Idaho', id: 'ID' },
  { label: 'Illinois', id: 'IL' },
  { label: 'Indiana', id: 'IN' },
  { label: 'Iowa', id: 'IA' },
  { label: 'Kansas', id: 'KS' },
  { label: 'Kentucky', id: 'KY' },
  { label: 'Louisiana', id: 'LA' },
  { label: 'Maine', id: 'ME' },
  { label: 'Marshall Islands', id: 'MH' },
  { label: 'Maryland', id: 'MD' },
  { label: 'Massachusetts', id: 'MA' },
  { label: 'Michigan', id: 'MI' },
  { label: 'Minnesota', id: 'MN' },
  { label: 'Mississippi', id: 'MS' },
  { label: 'Missouri', id: 'MO' },
  { label: 'Montana', id: 'MT' },
  { label: 'Nebraska', id: 'NE' },
  { label: 'Nevada', id: 'NV' },
  { label: 'New Hampshire', id: 'NH' },
  { label: 'New Jersey', id: 'NJ' },
  { label: 'New Mexico', id: 'NM' },
  { label: 'New York', id: 'NY' },
  { label: 'North Carolina', id: 'NC' },
  { label: 'North Dakota', id: 'ND' },
  { label: 'Northern Mariana Islands', id: 'MP' },
  { label: 'Ohio', id: 'OH' },
  { label: 'Oklahoma', id: 'OK' },
  { label: 'Oregon', id: 'OR' },
  { label: 'Palau', id: 'PW' },
  { label: 'Pennsylvania', id: 'PA' },
  { label: 'Puerto Rico', id: 'PR' },
  { label: 'Rhode Island', id: 'RI' },
  { label: 'South Carolina', id: 'SC' },
  { label: 'South Dakota', id: 'SD' },
  { label: 'Tennessee', id: 'TN' },
  { label: 'Texas', id: 'TX' },
  { label: 'Utah', id: 'UT' },
  { label: 'Vermont', id: 'VT' },
  { label: 'Virgin Islands', id: 'VI' },
  { label: 'Virginia', id: 'VA' },
  { label: 'Washington', id: 'WA' },
  { label: 'West Virginia', id: 'WV' },
  { label: 'Wisconsin', id: 'WI' },
  { label: 'Wyoming', id: 'WY' },
];

const inspectionPurposeOptions = [
  { label: 'New', id: 'new' },
  { label: 'Claim', id: 'claim' },
  { label: 'Pre-binding', id: 'pre-binding' },
  { label: 'Renewal', id: 'renewal' },
  { label: 'Special', id: 'special' },
  { label: 'Underwriting', id: 'underwriting' },
];

const archivedOptions = [
  { label: 'Both Active and Archived', id: 'both' },
  { label: 'Archived Only', id: 'archived' },
  { label: 'Active Only', id: 'active' },
];

export const configuredFilters: Filter[] = [
  {
    type: FilterType.TEXTWITHOR,
    name: 'policyNumber',
    label: 'Policy Number',
    group: 'Policy',
  },
  {
    type: FilterType.DATE,
    name: 'policyEffectiveDate',
    label: 'Policy Effective Date',
    group: 'Policy',
  },
  {
    type: FilterType.SELECT,
    name: 'productType',
    label: 'Product Type',
    options: [],
    group: 'Policy',
  },
  {
    type: FilterType.TEXTWITHOR,
    name: 'brokerName',
    label: 'Broker Name',
    group: 'Policy',
  },
  {
    type: FilterType.TEXTWITHOR,
    name: 'customerName',
    label: 'Customer Name',
    group: 'Customer',
  },
  {
    type: FilterType.TEXTWITHOR,
    name: 'contactName',
    label: 'Contact Name',
    group: 'Customer',
  },
  {
    type: FilterType.TEXTWITHOR,
    name: 'contactEmail',
    label: 'Contact Email',
    group: 'Customer',
  },
  {
    type: FilterType.TEXTWITHOR,
    name: 'contactPhone',
    label: 'Contact Phone',
    group: 'Customer',
  },
  {
    type: FilterType.TEXTWITHOR,
    name: 'locationId',
    label: 'Location ID',
    group: 'Location',
  },
  {
    type: FilterType.TEXT,
    name: 'location',
    label: 'Coordinates (lat, long)',
    group: 'Location',
    operatorLabel: 'in Radius of 10 miles from',
    placeholder: 'xx.xxx, xx.xxx',
    validation: {
      type: 'regex',
      pattern:
        '^[-+]?([1-8]?\\d(\\.\\d{2,})?|90(\\.0{2,})?),\\s*[-+]?(180(\\.0{2,})?|((1[0-7]\\d)|([1-9]?\\d))(\\.\\d{2,})?)$',
      message: 'Please enter lat and long coordinates in decimal format separated by a comma.',
    },
  },
  {
    type: FilterType.TEXTWITHOR,
    name: 'address',
    label: 'Address',
    group: 'Location',
  },
  {
    type: FilterType.TEXTWITHOR,
    name: 'city',
    label: 'City',
    group: 'Location',
  },
  {
    type: FilterType.TEXTWITHOR,
    name: 'zip',
    label: 'Zip',
    group: 'Location',
  },
  {
    type: FilterType.TEXTWITHOR,
    name: 'state',
    options: usStates,
    label: 'State',
    group: 'Location',
  },
  {
    type: FilterType.TEXTWITHOR,
    name: 'assigneeName',
    label: 'Assignee',
    group: 'Inspection',
  },
  {
    type: FilterType.TEXTWITHOR,
    name: 'inspectorName',
    label: 'Inspector Name',
    group: 'Inspection',
  },
  {
    type: FilterType.DATE,
    name: 'dueDate',
    label: 'Due Date',
    group: 'Inspection',
  },
  {
    type: FilterType.DATE,
    name: 'lastSynced',
    label: 'Sync Date',
    group: 'Inspection',
  },
  {
    type: FilterType.DATE,
    name: 'recommendationDueDate',
    label: 'Recommendation Due Date',
    group: 'Inspection',
  },
  {
    type: FilterType.TEXTWITHOR,
    name: 'purpose',
    label: 'Purpose',
    options: inspectionPurposeOptions,
    group: 'Inspection',
  },
  {
    type: FilterType.SELECT,
    name: 'status',
    label: 'Status',
    options: [],
    group: 'Inspection',
  },
  {
    type: FilterType.SELECT,
    name: 'underwritingStatus',
    label: 'Underwriting Status',
    options: [],
    group: 'Inspection',
  },
  {
    type: FilterType.SELECT,
    name: 'archivedStatus',
    label: 'Archived Status',
    options: archivedOptions,
    group: 'Inspection',
  },
  {
    type: FilterType.SELECT,
    name: 'version',
    label: 'Version name',
    options: [],
    group: 'Inspection',
  },
  {
    type: FilterType.SELECT,
    name: 'itemType',
    label: 'Item type',
    options: [],
    multi: true,
    group: 'Inspection',
  },
  {
    type: FilterType.TEXTWITHOR,
    name: 'customItemName',
    label: 'Custom Item Name',
    group: 'Inspection',
  },
  {
    type: FilterType.TEXTWITHOR,
    name: 'vendorName',
    label: 'Vendor Name',
    group: 'Vendor',
  },
];
